import {Suspense, useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit, useAuth} from './modules/auth'
import { CurrencyProvider } from '../_metronic/currency/CurrencyContextProvider'
import { Toaster, toast } from 'react-hot-toast'

import Echo from 'laravel-echo'
// @ts-ignore
import io from 'socket.io-client';

const App = () => {
  const {currentUser} = useAuth()

useEffect(() => {
  const testMode = true
  if (!currentUser && !testMode) return

  window.io = io

  const echo = new Echo({
    broadcaster: 'socket.io',
    host: 'https://api-vpro-hetz-afnet.afghannet.net:6001',
    key: 'test-key',
    transports: ['websocket'],
    forceTLS: true,
    enabledTransports: ['ws', 'wss'],
    disableStats: false,
  })

  echo.connector.socket.on('connect', () => {
    console.log('✅ WebSocket connected')
  })

  echo.connector.socket.on('disconnect', (reason: string) => {
    console.log('❌ Disconnected:', reason)
  })

  echo.connector.socket.on('connect_error', (error: Error) => {
    console.error('🔥 Connection error:', error)
  })

  // 👇 Make sure this exact channel and event name is used
  echo.channel('laravel_database_resellers-channel')
    .listen('.UserEvent', (e: any) => {
      console.log('🎯 Event received from server:', e)
      if (e?.title) {
        toast.success(e.title)
      } else {
        toast('📡 New event received')
      }
    })

  // Optional: debug raw message
  echo.connector.socket.on('message', (msg: any) => {
    console.log('📦 Raw WebSocket message:', msg)
  })
})


  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <CurrencyProvider>
        <I18nProvider>
          <LayoutProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
              <Toaster position="top-right" />
            </AuthInit>
          </LayoutProvider>
        </I18nProvider>
      </CurrencyProvider>
    </Suspense>
  )
}

export {App}
